import { render, staticRenderFns } from "./WsExamsShiftsListItem.vue?vue&type=template&id=712cf9a2"
import script from "./WsExamsShiftsListItem.vue?vue&type=script&lang=js"
export * from "./WsExamsShiftsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports